import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const useServicePublished = () => {
  const [values, setValues] = useState(null);
  const {
    t
  } = useTranslation();
  if (!values) {
    setValues([{
      label: t('GENERAL.published'),
      value: 'Y'
    }, {
      label: t('GENERAL.notPublished'),
      value: 'N'
    }]);
  }
  return values;
};
export { useServicePublished };